import React, { useEffect, useRef, useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  AccessoriesIcon,
  AddIconBlue,
  AddImageIcon,
  ApparelIcon,
  certificate,
  EditIconGray,
  EquipmentIcon,
  LinkIcon,
  logoColor,
  TrashIconGray,
  AddImageIconDisabled,
  PdfImg,
} from "../../../../constant/imagePath";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import classes from "./PersonalInfo.module.css";
import { Row, Col, Container } from "react-bootstrap";
import { Radio } from "../../../../stories/Radio/Radio";
import { Input } from "../../../../stories/Input/Input";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import { useHistory } from "react-router-dom";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { UploadedImageWithEditAndDelete } from "../../../../stories/UploadedImageWithEditAndDelete/UploadedImageWithEditAndDelete";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import PersonalInfoMobile from "./PersonalInfoMobile";
import EditPhotoModal from "../../../Modals/CoachFlow/OnBoarding/EditPhoto/EditPhoto";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import CertificateInformationCard from "../../../../stories/CertificateInformationCard/CertificateInformationCard";
import { ImageAndVideoBoxWithDeleteBtn } from "../../../../stories/ImageAndVideoBoxWithDeleteBtn/ImageAndVideoBoxWithDeleteBtn";

function PersonalInfoDesktop({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer?.personalInfo
  );
  const [coverPhoto, setCoverPhoto] = useState(
    getDataFromRedux?.coverPhoto ? getDataFromRedux?.coverPhoto : null
  );
  const [dob, setDob] = useState(
    getDataFromRedux?.dob ? getDataFromRedux?.dob : null
  );
  const [phoneNo, setPhoneNo] = useState(
    getDataFromRedux?.phone ? getDataFromRedux?.phone : ""
  );
  const [editedCoverPhoto, setEditedCoverPhoto] = useState(null);
  const [gender, setGender] = useState(
    getDataFromRedux?.gender ? getDataFromRedux?.gender : null
  );
  const [fullName, setFullName] = useState(
    getDataFromRedux?.fullName ? getDataFromRedux?.fullName : ""
  );
  const [aboutYourself, setAboutYourself] = useState(
    getDataFromRedux?.aboutYourself ? getDataFromRedux?.aboutYourself : ""
  );
  const [coachingExperience, setCoachingExperience] = useState(
    getDataFromRedux?.coachingExperience
      ? getDataFromRedux?.coachingExperience
      : ""
  );
  const [areaOfExpertise, setAreaOfExpertise] = useState(
    getDataFromRedux?.areaOfExpertise ? getDataFromRedux?.areaOfExpertise : ""
  );
  const [focusTags, setFocusTags] = useState(
    getDataFromRedux?.focusTags ? getDataFromRedux?.focusTags : []
  );
  const [levelsTaught, setLevelsTaught] = useState(
    getDataFromRedux?.levelsTaught ? getDataFromRedux?.levelsTaught : []
  );
  const [teaches, setTeaches] = useState(
    getDataFromRedux?.teaches ? getDataFromRedux?.teaches : []
  );
  const [addPhotpOrVideo, setAddPhotoOrVideo] = useState(
    getDataFromRedux?.addPhotpOrVideo ? getDataFromRedux?.addPhotpOrVideo : []
  );
  const [isEditingCover, setIsEditingCover] = useState(false);
  const [certificates, setCertificates] = useState([
    // {
    // title: "Professional Tennis Registry.jpg",
    // date: "10:15am, 10 Oct",
    // size: "1mb",
    // certificateImg:certificate
    // },
  ]);
  const history = useHistory();
  const coverRef = useRef(null);
  const multipleFilesRef = useRef(null);

  // Add Certficate States
  const certificateRef = useRef(null);
  const [certificateImg, setCertificateImg] = useState(null);
  const [certifications, setCertifications] = useState(null);
  const [expirationDate, setExpirationDate] = useState(null);

  function addCoverPhoto() {
    coverRef.current.click();
  }
  function editCoverPhoto() {
    coverRef.current.click();
    setEditedCoverPhoto(null);
  }
  function deleteCoverPhoto() {
    setCoverPhoto(null);
    setEditedCoverPhoto(null);
  }

  console.log({ getDataFromRedux });

  // Save And Finish Later
  function saveAndFinishLater() {
    const res = {
      coverPhoto,
      gender,
      fullName,
      aboutYourself,
      coachingExperience,

      areaOfExpertise,
      focusTags,
      levelsTaught,
      teaches,
      certificates,
      addPhotpOrVideo,
    };
    dispatch(setPersonalData("personal-info", res));
  }
  console.log({ certificates });

  return (
    <div className={classes.personalInfo}>
      <style jsx>{`
        .${classes.multipleImageCard}::before {
          background-color: ${Colors.neutralShadesOfNero}80;
        }
      `}</style>

      <Row className={`g-0 ${classes.row}`}>
        <div className={classes.progressLine}>
          <PageProgressBar progress={"33.3%"} />
        </div>
        <Col md={12} className={`${[classes.saveAndFinish].join(" ")}`}>
          <LinkButtonWithIcon
            primary={false}
            text={"Save and Finish Later"}
            customStyle={{ ...Fonts.b2, lineHeight: "20px" }}
            onClick={saveAndFinishLater}
          />
        </Col>
        <Col md={12}>
          <Container
            fluid
            className={` ${[classes.personalInfoForm].join(" ")}`}
          >
            <Col md={12}>
              <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                Personal Info
              </h3>
              <p
                className={`${[classes.formTagline].join(" ")}`}
                style={{
                  ...Fonts.p2,
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                Introduce yourself to your students
              </p>
            </Col>
            <Col md={12} className={`${[classes.mb80].join(" ")}`}>
              {editedCoverPhoto !== null ? (
                <UploadedImageWithEditAndDelete
                  image={editedCoverPhoto}
                  editClick={() => editCoverPhoto()}
                  deleteClick={() => deleteCoverPhoto()}
                />
              ) : (
                <Button
                  customStyle={{
                    border: `1px dashed ${Colors.neutralShadesOfGainsboro}`,
                    height: "64px",
                    borderRadius: "10px",
                    width: "100%",
                    color: Colors.mainBlue,
                  }}
                  icon={AddImageIcon}
                  size={"Medium"}
                  onClick={addCoverPhoto}
                  label={"Add cover photo"}
                />
              )}

              <input
                className="d-none"
                accept="image/*"
                type={"file"}
                ref={coverRef}
                onChange={(e) => {
                  console.log("aaa");
                  setCoverPhoto(e.target.files[0]);
                  setIsEditingCover(true);
                }}
                onClick={(event) => {
                  event.target.value = null;
                }}
              />
            </Col>
            <Col md={12} className={`${[classes.mb80].join(" ")}`}>
              <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                Your Gender
              </h5>
              <DropDown
                state={gender}
                setter={setGender}
                label=""
                options={[
                  { label: "Male", value: "Male" },
                  { label: "Female", value: "Female" },
                  { label: "Other", value: "Other" },
                ]}
                placeholder={"Select your gender"}
              />
              {/* <div className={`d-flex ${[classes.genderRadios].join(" ")}`}>
                <span>
                  <Radio label="Female" value={gender} setValue={setGender} />
                </span>
                <span>
                  <Radio label="Male" value={gender} setValue={setGender} />
                </span>
                <span>
                  <Radio label="Others" value={gender} setValue={setGender} />
                </span>
              </div> */}
            </Col>
            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                About You
              </h5>
              <Input
                label={"Full Name"}
                state={fullName}
                setter={setFullName}
                placeholder=""
                inputStyle={{ height: "48px" }}
              />
            </Col>
            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <Input
                label={"Phone number"}
                state={phoneNo}
                setter={setPhoneNo}
                placeholder=""
                inputStyle={{ height: "48px" }}
              />
            </Col>
            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <Input
                label={"Date of birth"}
                state={dob}
                setter={setDob}
                placeholder=""
                inputStyle={{ height: "48px" }}
              />
            </Col>
            <Col md={12} className={`${[classes.mb80].join(" ")}`}>
              <TextArea
                label={
                  "Tell a little about yourself. What makes you a great coach?"
                }
                placeholder={""}
                state={aboutYourself}
                setter={setAboutYourself}
                textAreaStyle={{ minHeight: "164px", maxHeight: "164px" }}
              />
            </Col>
            <Col md={12}>
              <div className={`${[classes.spaceBetween].join(" ")}`}>
                <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                  Credentials and Experience
                </h5>
                <span
                  style={{
                    ...Fonts.p4,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Optional
                </span>
              </div>
            </Col>
            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <TextArea
                placeholder=""
                label="What is your area of expertise?"
                state={areaOfExpertise}
                setter={setAreaOfExpertise}
              />
            </Col>
            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <Input
                label={"Extensive coaching experience"}
                state={coachingExperience}
                setter={setCoachingExperience}
                placeholder=""
                inputStyle={{ height: "48px" }}
              />
            </Col>
            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <DropDown
                label={
                  "Focus tags (What part of the game can you improve your student?)"
                }
                isMulti={true}
                state={focusTags}
                setter={setFocusTags}
                options={[
                  { value: "Forehand", label: "Forehand" },
                  { value: "Backhand", label: "Backhand" },
                  { value: "Volley", label: "Volley" },
                  { value: "Serve", label: "Serve" },
                  { value: "Slice", label: "Slice" },
                  { value: "Mobility", label: "Mobility" },
                ]}
              />
            </Col>
            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <DropDown
                label={"Levels Taught"}
                isMulti={true}
                state={levelsTaught}
                setter={setLevelsTaught}
                options={[
                  { value: "Beginner", label: "Beginner" },
                  { value: "Intermediate", label: "Intermediate" },
                  { value: "Advanced", label: "Advanced" },
                  { value: "Expert", label: "Expert" },
                ]}
              />
            </Col>
            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <DropDown
                label={"Teaches"}
                isMulti={true}
                state={teaches}
                setter={setTeaches}
                options={[{ value: "Kids", label: "Kids" }]}
              />
            </Col>
            <Col md={12}>
              <div className={classes.certificationsInputs}>
                <div className="">
                  <DropDown
                    label={
                      "What certifications/licenses do you hold? (Optional)"
                    }
                    state={certifications}
                    setter={setCertifications}
                    placeholder="Select Certificate"
                    options={[
                      { value: "ABC", label: "ABC" },
                      { value: "XYZ", label: "XYZ" },
                    ]}
                  />
                </div>
                <div>
                  <Input
                    placeholder={"Expiration Date"}
                    state={expirationDate}
                    setter={setExpirationDate}
                    inputStyle={{ height: "48px" }}
                  />
                </div>
                <div>
                  <Button
                    icon={LinkIcon}
                    customStyle={{
                      height: "48px",
                      width: "48px",
                      padding: "12px",
                    }}
                    onClick={() => {
                      certificateRef.current.click();
                    }}
                  />
                  {/* Hidden Input For Certificate Img */}
                  <input
                    type={"file"}
                    ref={certificateRef}
                    className={"d-none"}
                    accept="image/png, image/jpeg, application/pdf"
                    onChange={(e) => setCertificateImg(e.target.files[0])}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                  />
                </div>
              </div>
            </Col>
            {/* Render Certificates */}
            {certificates.map((item) => {
              return (
                <Col md={12} key={item?._id}>
                  <CertificateInformationCard
                    data={item}
                    onDelete={() => {
                      const newArr = [...certificates];
                      const index = newArr.findIndex((d) => d._id);
                      newArr.splice(index, index + 1);
                      setCertificates(newArr);
                    }}
                  />
                </Col>
              );
            })}
            {/* Add Certficate */}
            <Col
              md={12}
              className={`${[classes.mb80, classes.mt24].join(" ")}`}
            >
              <LinkButtonWithIcon
                primary={true}
                text={"Add certificate"}
                leftIcon={AddIconBlue}
                disabled={
                  certifications == null ||
                  expirationDate == "" ||
                  certificateImg == null
                    ? true
                    : false
                }
                onClick={() => {
                  const newArr = [...certificates];
                  newArr.push({
                    _id: Math.floor(Math.random() * 10000),
                    title: certifications?.label,
                    size: Math.ceil(certificateImg?.size / (1024 * 1024)),
                    date: expirationDate,
                    certificateImg: certificateImg,
                  });
                  setCertificates(newArr);
                  setCertifications(null);
                  setExpirationDate("");
                  setCertificateImg(null);
                }}
              />
            </Col>

            <Col md={12} className={classes.mb32}>
              <div className={`${[classes.spaceBetween].join(" ")}`}>
                <h6 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                  Gallery
                </h6>
                <span
                  style={{
                    ...Fonts.p4,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Optional
                </span>
              </div>
              <p
                className={`${[classes.addUpto].join(" ")}`}
                style={{
                  ...Fonts.p1,
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                You can upload a maximum of 8 photos or videos
              </p>
            </Col>

            <Col md={12} className={`${[classes.mb32].join(" ")}`}>
              <Button
                primary={false}
                className={classes.addImageBtn}
                icon={AddImageIcon}
                size={"Medium"}
                label={"Add photo or video"}
                onClick={() => multipleFilesRef?.current?.click()}
                disabled={addPhotpOrVideo?.length >= 8}
                disabledIcon={AddImageIconDisabled}
              />

              {/* Hidden Input */}
              <input
                type="file"
                accept="video/*, image/*"
                className="d-none"
                ref={multipleFilesRef}
                multiple
                onChange={(e) => {
                  let newArr = addPhotpOrVideo.slice();

                  newArr = [...newArr, ...e.target.files];
                  setAddPhotoOrVideo(newArr?.slice(0, 8));
                }}
                onClick={(event) => {
                  event.target.value = null;
                }}
              />
            </Col>

            <Col md={12}>
              {addPhotpOrVideo?.length > 0 && (
                <h6
                  className={classes.noOfUploadedFiles}
                  style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}
                >
                  Uploaded{" "}
                  <span style={{ ...Fonts.h9, color: Colors.mainBlue }}>
                    {addPhotpOrVideo?.length}
                  </span>{" "}
                  of 8 files
                </h6>
              )}
              <Row>
                {addPhotpOrVideo?.map((item, i) => {
                  return (
                    <Col md={4}>
                      <ImageAndVideoBoxWithDeleteBtn
                        item={item}
                        state={addPhotpOrVideo}
                        setter={setAddPhotoOrVideo}
                      />
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Container>
        </Col>
        {/* Buttons Col */}
        <Col
          md={12}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          className={classes.btnsCol}
        >
          <div className={classes.btnsBox}>
            <Button
              label={"Back"}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => history.goBack()}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => {
                saveAndFinishLater();
                stepForwardAndBackward(1, 2);
              }}
            />
          </div>
        </Col>
      </Row>

      {/* Edit Photo Modal */}
      {isEditingCover && (
        <EditPhotoModal
          show={isEditingCover}
          setShow={setIsEditingCover}
          state={coverPhoto}
          onSave={setEditedCoverPhoto}
        />
      )}
    </div>
  );
}

// Decide Personal Info
export default function PersonalInfo({ stepForwardAndBackward }) {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? (
    <PersonalInfoMobile stepForwardAndBackward={stepForwardAndBackward} />
  ) : (
    <PersonalInfoDesktop stepForwardAndBackward={stepForwardAndBackward} />
  );
}
